var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-theme-provider',{attrs:{"dark":_vm.dark}},[_c('div',[_c('base-info-card',{attrs:{"title":"KEEP IN TOUCH","pace":"6"}},[_vm._v(" Have a question? Contact us below. ")]),_c('base-business-contact',{attrs:{"dense":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }